/**
 * Подписки React на звонок, живущий вне экрана (см. `callSessionStore`). Отдельно от самого
 * хранилища: его правила проверяются тестами без React, а сюда — только обёртки.
 */
import { useSyncExternalStore } from 'react';
import {
  getAttachedCallScreenKey,
  getCallSessionLive,
  getCallSessionMeta,
  subscribeCallScreenAttachment,
  subscribeCallSessionLive,
  subscribeCallSessionMeta,
  type CallSessionLive,
  type CallSessionMeta,
} from './callSessionStore';

/** Какой звонок идёт: меняется раз за звонок. */
export function useCallSessionMeta(): CallSessionMeta | null {
  return useSyncExternalStore(subscribeCallSessionMeta, getCallSessionMeta, getCallSessionMeta);
}

/** Снимок идущего звонка: меняется на каждое изменение сессии. */
export function useCallSessionLive<Vc, Extra>(): CallSessionLive<Vc, Extra> | null {
  return useSyncExternalStore(
    subscribeCallSessionLive,
    getCallSessionLive,
    getCallSessionLive,
  ) as CallSessionLive<Vc, Extra> | null;
}

/** Ключ сессии на открытом экране звонка, или `null`, если экран закрыт (звонок свёрнут). */
export function useAttachedCallScreenKey(): number | null {
  return useSyncExternalStore(
    subscribeCallScreenAttachment,
    getAttachedCallScreenKey,
    getAttachedCallScreenKey,
  );
}
